export default __webpack_public_path__ + "static/media/wdtxd.4dc783e8.png";